<template>
    <Modal v-model.sync="$api.imgPreview.flag" class='publicModel delModelFoot' width='600px' title="图片预览图">
        <img :src="imgUrl+$api.imgPreview.url" alt="">
    </Modal>
</template>
<script>
    export default {
        data(){
            return {
                flag:this.$api.imgPreview,
            }
        },
        methods:{
        },
    }
</script>
<style scoped>
.publicModel img{
    margin: 0 auto;
    display: block;
}
</style>